import { defineAction } from "@agent-native/core/action";
import { z } from "zod";

import { listAuditEvents } from "../server/lib/dispatch-store.js";

export default defineAction({
  description: "List recent dispatch audit events.",
  schema: z.object({
    limit: z.coerce.number().int().min(1).max(200).optional(),
  }),
  http: { method: "GET" },
  run: async ({ limit }) => listAuditEvents(limit || 50),
});
